import gql from 'graphql-tag';

import { courseCategoryFragment } from '~/shared/graphql-queries/course-categories/index';

export default gql`
  query findManyCourseCategoryQuery(
    $limit: Int
    $filter: FilterFindManyCourseCategoryInput
  ) {
    findManyCourseCategoryQuery(
      filter: $filter
      skip: 0
      limit: $limit
      sort: _ID_DESC
    ) {
      ...CourseCategoryFragment
    }
  }
  ${courseCategoryFragment}
`;
